<template>
  <v-row v-if="buttons.length" no-gutters class="mt-6">
    <v-col
      v-for="(button, index) in buttons"
      :key="index"
      :cols="$vuetify.breakpoint.smAndDown ? 12 : 12 / buttons.length"
      :class="{
        'pr-1': !$vuetify.breakpoint.smAndDown && index < buttons.length - 1,
        'pl-1': !$vuetify.breakpoint.smAndDown && index !== 0,
        'pb-2': $vuetify.breakpoint.smAndDown
      }"
    >
      <SendButton
        v-if="button.type === 'sendButton'"
        v-bind="button.props"
        :button-text="button.text"
        :block="isButtonBlock(button)"
        :color="buttonColor(button)"
        v-on="button.events"
      />
      <v-btn
        v-else
        v-bind="button.props"
        :block="isButtonBlock(button)"
        :color="buttonColor(button)"
        v-on="button.events"
      >
        <span v-html="button.text" />
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'DynamicFormButtons',
  props: {
    buttons: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isButtonBlock(button) {
      return button?.props?.block || true;
    },
    buttonColor(button) {
      return button?.props?.color || 'primary';
    }
  }
};
</script>
